"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignGroupOpenAs = exports.CampaignGroupTileType = void 0;
var CampaignGroupTileType;
(function (CampaignGroupTileType) {
    CampaignGroupTileType["PRODUCT"] = "product";
    CampaignGroupTileType["IMAGE"] = "image";
    CampaignGroupTileType["TEXT"] = "text";
})(CampaignGroupTileType || (exports.CampaignGroupTileType = CampaignGroupTileType = {}));
var CampaignGroupOpenAs;
(function (CampaignGroupOpenAs) {
    CampaignGroupOpenAs["LINK"] = "link";
    CampaignGroupOpenAs["MINI_PDP"] = "minipdp";
    CampaignGroupOpenAs["NONE"] = "none";
    CampaignGroupOpenAs["MINI_PDP_MULTI"] = "minipdp-multiple-products";
})(CampaignGroupOpenAs || (exports.CampaignGroupOpenAs = CampaignGroupOpenAs = {}));
//# sourceMappingURL=CampaignGroupTypes.js.map